import React from "react"
import contact from "../Styles/Contactus.css"
const Contactus = ()=>
{
    return(
        <div className="contactdiv">
            <h6>E-mail : mdnadeem3339@gmail.com</h6>
            <a href = "mailto: mdnadeem3339@gmail.com">Click here to send e-mail</a>
        </div>
    )
}
export default Contactus;